export default {
  DEBOUNCE_DELAY: 200,
  LOADING_FADE: 400,
  UNLOADING_FADE: 400,
  ROW_EXPANDER_TRANSITION: 150,
  HIDE_ADD_MAPPING_FORM: 300
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/courage/src/util/Time.js
// module id = 30
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/util/Time.js